import {
    createOptionPickerComponent,
    IOptionPickerItem,
    OptionPicker,
    OptionPickerType,
} from '@vfde-brix/option-picker';

/**
 * Mount the option picker
 * @param container
 * @param uuid
 * @param optType
 * @param items
 * @param onChange
 */
const mountOptionPicker = (containerId: string, uuid: string, optType: OptionPickerType, items: IOptionPickerItem[], onChange: (Event: Event) => void): OptionPicker => {
    const containerElement = document.getElementById(containerId) as HTMLElement;

    return createOptionPickerComponent(containerElement, {
        items,
        optType,
        uuid,
        business: {
            onChange,
        },
    });
};

export default mountOptionPicker;
